import { toast as customToast } from '@/components/custom-toast'
import { CustomToastProgress } from './custom-toast-progress'

interface Props {
  tier: string
  numberOfCustomRanches: number
}

export const showRanchLimitToast = ({ tier, numberOfCustomRanches }: Props) => {
  const title = 'Number of ranches exceeded'
  const message = `You have reached the total number of ranches ${numberOfCustomRanches} included with your ${tier} plan. Upgrade your plan to create more ranches.`

  return customToast.custom({
    renderLayout: (toastId) => (
      <CustomToastProgress
        toastId={toastId}
        title={title}
        description={message}
      />
    ),
    duration: 100000,
  })
}
